import { defineSemanticTokens } from '@chakra-ui/react';

export const radii = defineSemanticTokens.radii({
  l1: {
    value: '{radii.xl}',
  },
  l2: {
    value: '{radii.2xl}',
  },
  l3: {
    value: '{radii.3xl}',
  },
  l4: {
    value: '{radii.4xl}',
  },
});
